import type { AppLocale } from '@kcm/contracts'
import { en, type MessageKey, type Messages } from './en.js'
import { th } from './th.js'
import { vi } from './vi.js'
import { tw } from './tw.js'
import { cn } from './cn.js'
import { ja } from './ja.js'
import { ko } from './ko.js'

export type { MessageKey, Messages }
export { en }

/** The bundled fallback catalog for every launch locale (PLAN.md §17). */
export const catalogs: Record<AppLocale, Messages> = { en, th, vi, tw, cn, ja, ko }

/** Endonyms for the language switcher — a user recognises their own language. */
export const LOCALE_NATIVE_NAME: Record<AppLocale, string> = {
  en: 'English',
  th: 'ไทย',
  vi: 'Tiếng Việt',
  tw: '繁體中文',
  cn: '简体中文',
  ja: '日本語',
  ko: '한국어',
}
